const retailers = [
	{
		path: '/deals/stores',
		name: 'shop-retailers-list',
		component: () => import('@/views/shop/retailers/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,product-suppliers',
		},
	},
]

export default retailers
